export type ProfileCompletionFields = {
  hasCompletedProfile?: boolean;
  phone?: string;
  address?: {
    country?: string;
    state_province?: string;
  };
};

/** Whether required onboarding fields (phone, country, state) are present. */
export function deriveProfileComplete(client: ProfileCompletionFields | null | undefined): boolean {
  if (!client) return false;
  if (client.hasCompletedProfile === true) return true;

  const phoneDigits = (client.phone ?? '').replace(/\D/g, '');
  const country = (client.address?.country ?? '').trim();
  const state = (client.address?.state_province ?? '').trim();

  return phoneDigits.length >= 7 && country.length > 0 && state.length > 0;
}
